import './EmptyPage.scss';

function EmptyPage({ children }) {
  return <div className="empty-page">{children}</div>;
}

export default EmptyPage;
